import React from 'react';
import styles from './AlertCard.module.css';
import type { ForemanAlert } from '../../types/foreman';

interface AlertCardProps {
  alert: ForemanAlert;
}

const TYPE_ICONS: Record<string, string> = {
  scope: '!',
  co: '$',
  info: 'i',
  success: '\u2713',
  critical: '\u2716',
};

function getTypeClass(type: string): string {
  const normalized = type.toLowerCase().replace(/[-_\s]/g, '');
  if (normalized === 'scope' || normalized === 'scopegap') return styles.scope;
  if (normalized === 'co' || normalized === 'changeorder') return styles.co;
  if (normalized === 'success') return styles.success;
  if (normalized === 'critical') return styles.critical;
  return styles.info;
}

function getIcon(type: string): string {
  const normalized = type.toLowerCase().replace(/[-_\s]/g, '');
  if (normalized === 'scope' || normalized === 'scopegap') return TYPE_ICONS.scope;
  if (normalized === 'co' || normalized === 'changeorder') return TYPE_ICONS.co;
  if (normalized === 'success') return TYPE_ICONS.success;
  if (normalized === 'critical') return TYPE_ICONS.critical;
  return TYPE_ICONS.info;
}

const AlertCard: React.FC<AlertCardProps> = ({ alert }) => {
  const typeClass = getTypeClass(alert.type);
  const icon = getIcon(alert.type);

  return (
    <div className={`${styles.card} ${typeClass}`}>
      <div className={styles.iconWrapper}>{icon}</div>
      <div className={styles.body}>
        <div className={styles.title}>{alert.title}</div>
        <div className={styles.text}>{alert.text}</div>
      </div>
    </div>
  );
};

export default AlertCard;
